import * as def from '@/definitions'
import { TextInfo } from '@/utilityModels/textInfo'
import { Layer } from './layer';
import { ArrayHelper } from '@/helper/arrayHelper';
import { StringHelper } from '@/helper/stringHelper';
import { ObjectLayer } from './objectLayer';
import { DateHelper } from '@/helper/dateHelper';
import { Document } from '@/model/document2/document';
import { StoreModule } from '@/storeModule/storeModule';
import { UuidHelper } from '@/helper/uuidHelper';

// 連番レイヤーへの参照を保持
// designで保持する
export class NumberLayer extends Layer
{
    public get layerType() { return "number"; }

    // 参照Id
    private _linkId = "";
    public get linkId() { return this._linkId; }
    public set linkId(linkId) { this._linkId = linkId; }

    // documentへの参照
    // この値は保存せず、documentはNumberLayer新規作成時、もしくはdocumentのロード時に与える
    public document : Document | null = null;

    // 各パラメータはコアを使用する
    public get x() : number
    {
        if(this.document == null) { return 0; }
        return this.getCoreLayer().x;
    } 
    public set x(x : number)
    {
        if(this.document == null) { return; }
        this.getCoreLayer().x = x;
    }

    public get y() : number
    {
        if(this.document == null) { return 0; }
        return this.getCoreLayer().y;
    } 
    public set y(y : number)
    {
        if(this.document == null) { return; }
        this.getCoreLayer().y = y;
    }

    public get width() : number
    {
        if(this.document == null) { return 0; }
        return this.getCoreLayer().width;
    }
    public set width(width : number)
    {
        if(this.document == null) { return; }
        this.getCoreLayer().width = width;
    }

    public get height() : number
    {
        if(this.document == null) { return 0; }
        return this.getCoreLayer().height;
    }
    public set height(height : number)
    {
        if(this.document == null) { return; }
        this.getCoreLayer().height = height;
    }

    public get rotate() : number
    {
        if(this.document == null) { return 0; }
        return this.getCoreLayer().rotate;
    }
    public set rotate(rotate : number)
    {
        if(this.document == null) { return; }
        this.getCoreLayer().rotate = rotate;
    }

    public get originX() : number
    {
        if(this.document == null) { return 0; }
        return this.getCoreLayer().originX;
    }

    public get originY() : number
    {
        if(this.document == null) { return 0; }
        return this.getCoreLayer().originY;
    }

    // 対象となるsurface
    public get surfaceIndex() { return this.getCoreLayer().surfaceIndex; }
    public set surfaceIndex(surfaceIndex) { this.getCoreLayer().surfaceIndex = surfaceIndex; }

    // 文法情報
    public get textInfo() { return this.getCoreLayer().textInfo; }
    public set textInfo(textInfo) { this.getCoreLayer().textInfo = textInfo; }

    // 不透明度(%)
    public get opacity() { return this.getCoreLayer().opacity; }
    public set opacity(opacity) { this.getCoreLayer().opacity = opacity; }

    // 開始番号
    public get startNumber() { return this.getCoreLayer().startNumber; }
    public set startNumber(startNumber) { this.getCoreLayer().startNumber = startNumber; }

    // 桁数(0の場合は表示なし)
    public get digits() { return this.getCoreLayer().digits; }
    public set digits(digits) { this.getCoreLayer().digits = digits; }

    // 増分
    public get step() { return this.getCoreLayer().step; }
    public set step(step) { this.getCoreLayer().step = step; }

    // 自動(文字を枠に合わせたサイズにする)
    public get autoSize() : boolean { return this.getCoreLayer().autoSize; }
    public set autoSize(autoSize : boolean) { this.getCoreLayer().autoSize = autoSize; }

    // 自動折り返し(ある程度で折り返す)
    public get autoNewLine() : boolean { return this.getCoreLayer().autoNewLine; }
    public set autoNewLine(autoNewLine : boolean) { this.getCoreLayer().autoNewLine = autoNewLine; }

    // 行間(%)
    public get lineSpacing() : number { return this.getCoreLayer().lineSpacing; }
    public set lineSpacing(lineSpacing) { this.getCoreLayer().lineSpacing = lineSpacing; }
    
    // 文字方向
    // 0: 横書き
    // 1: 縦書き
    public get textOrientation() : number { return this.getCoreLayer().textOrientation; }
    public set textOrientation(textOrientation : number ) { this.getCoreLayer().textOrientation = textOrientation; }

    // 水平揃え
    // 0: 左
    // 1: 中央
    // 2: 右
    // 3: 均等
    public get horizontalAlignment() : number { return this.getCoreLayer().horizontalAlignment; }
    public set horizontalAlignment(horizontalAlignment : number) { this.getCoreLayer().horizontalAlignment = horizontalAlignment; }

    // 垂直揃え
    // 0: 上
    // 1: 中央
    // 2: 下
    public get verticalAlignment() : number { return this.getCoreLayer().verticalAlignment; }
    public set verticalAlignment(verticalAlignment : number) { this.getCoreLayer().verticalAlignment = verticalAlignment; }

    // 語頭追加
    public get prefix() : string { return this.getCoreLayer().prefix; }
    public set prefix(prefix : string) { this.getCoreLayer().prefix = prefix; }

    // 語尾追加
    public get suffix() : string { return this.getCoreLayer().suffix; }
    public set suffix(suffix : string) { this.getCoreLayer().suffix = suffix; }

    // フォーマット
    public get format() : string { return this.getFormat(); }
    public set format(format) { this.setFormat(format); }

    private getCurrentSurfaceIndex()
    {
        if(this.document != null && this.document.hasReverseSurface)
        {
            for(var pageIndex = 0; pageIndex < this.document.pageCount; ++pageIndex)
            {
                var page = this.document.pageList[pageIndex];
                for(var sindex = 0; sindex < (page.hasReverse ? 2 : 1); ++sindex)
                {
                    var surface = page.getSurface(sindex == 1);
                    for(var pos = 0; pos < page.designMaxNumber; ++pos)
                    {
                        var design = surface.getDesign(pos);
                        if(design != null)
                        {
                            var allLayers = design.getAllLayers(false);
                            for(var i = 0; i < allLayers.length; ++i)
                            {
                                if(allLayers[i] == this)
                                {
                                    return sindex;
                                }
                            }
                        }
                    }
                }
            }
        }
        return 0;
    }

    public updateDocument(isAdd)
    {
        if(this.document == null) { return; }

        if(isAdd)
        {
            // surfaceIndex更新
            this.getCoreLayer().surfaceIndex = this.getCurrentSurfaceIndex();

            this.document.updateDesignAfterAddNumberLayer(this);
        }
        else
        {
            this.document.updateDesignAfterRemoveNumberLayer(this);
        }
    }

    public getFormat()
    {
        // 桁数0の場合は表示しない
        if(this.digits == 0) { return ""; }

        // この番号
        var num = this.startNumber;
        // 番号を0埋めする
        var str = "" + num;
        var strLength = str.length;
        if(strLength < this.digits)
        {
            for(var i = 0; i < this.digits - strLength; ++i)
            {
                str = "0" + str;
            }
        }

        return str;
    }

    public setFormat(format : string)
    {
        if(format == "")
        {
            // 空文字の場合は開始文字1 桁数0と判定
            this.startNumber = 1;
            this.digits = 0;
            return;
        }
        // 入力文字が数字かどうか
        var pattern = /^\d*$/;
        var reg = new RegExp(pattern);
        if(!reg.test(format))
        {
            // 数字では無い場合はそのまま返す
            return;
        }

        // 数値化して設定する
        this.startNumber = Number(format);
        this.digits = format.length;
    }

    public getText()
    {
        if(this.document == null) { return ""; }
        // 桁数0の場合は表示しない
        if(this.digits == 0) { return ""; }

        // まずこのレイヤーの入っているデザインが、何番目に当たるのかを得る
        var totalIndex = this.getTotalDesignIndex();

        // この番号
        var num = this.startNumber + totalIndex * this.step;
        var isMinus = false;
        if(num < 0)
        {
            num *= -1;
            isMinus = true;
        }
        // 番号を0埋めする
        var str = "" + num;
        var strLength = str.length;
        if(strLength < this.digits)
        {
            for(var i = 0; i < this.digits - strLength; ++i)
            {
                str = "0" + str;
            }
        }

        if(isMinus)
        {
            // マイナス追加
            str = "-" + str;
        }

        // 語頭・語尾追加
        str = this.prefix + str + this.suffix;

        if(this.textInfo.isEmQuad)
        {
            // 全角が設定されている場合は、文字列を全角変換する
            str = StringHelper.toEmQuadString(str);
        }

        return str;
    }

    public getTotalDesignIndex()
    {
        if(this.document == null) { return 0; }
        var totalIndex = 0;
        for(var pageIndex = 0; pageIndex < this.document.pageCount; ++pageIndex)
        {
            var page = this.document.pageList[pageIndex];
            var surface = page.getSurface(this.surfaceIndex == 1);
            for(var designIndex = 0; designIndex < page.designMaxNumber; ++designIndex)
            {
                var design = surface.getDesign(designIndex);
                if(design != null)
                {
                    var allLayers = design.getAllLayers(false);
                    for(var i = 0; i < allLayers.length; ++i)
                    {
                        if(allLayers[i] == this)
                        {
                            return totalIndex;
                        }
                    }
                }
                // インデックス進める
                totalIndex++;
            }
        }
        return 0;
    }

    // 作成
    public static create(document : Document, x : number, y : number, width : number, height : number) : NumberLayer
    {
        var layer = new NumberLayer();
        
        // ドキュメントへの参照を保持する
        layer.document = document;

        // コアレイヤーを作成
        var coreLayer = NumberCoreLayer.create(x, y, width, height);
        // リンクする
        var linkId = UuidHelper.getUuid();
        coreLayer.linkId = linkId;
        layer.linkId = linkId;
        // コアレイヤーをdocumentに追加
        document.numberLayers.push(coreLayer);

        // 対象surfaceをセット
        layer.surfaceIndex = document.isReverseSurface ? 1 : 0;
        
        return layer;
    }

    // 複製
    public clone()
    {
        var cloned = new NumberLayer();
        this.cloneParameter(cloned);
        return cloned;
    }

    public cloneParameter(layer : NumberLayer)
    {
        if(this.document == null) { return; }
        // linkIdをcloneすると、同じNumberCoreLayerを参照してしまい、複製にならないので、
        // 新しく作り直す。
        //layer.linkId = this._linkId;
        // コアレイヤーを作成
        var orgCoreLayer : NumberCoreLayer | null = null;
        for(var i = 0; i < this.document.numberLayers.length; ++i)
        {
            if(this.document.numberLayers[i].linkId == this.linkId)
            {
                orgCoreLayer = this.document.numberLayers[i];
                break;
            }
        }
        if(orgCoreLayer == null) { return; }
        var coreLayer = orgCoreLayer.clone();
        // リンクする
        var linkId = UuidHelper.getUuid();
        coreLayer.linkId = linkId;
        layer.linkId = linkId;
        // コアレイヤーをdocumentに追加
        this.document.numberLayers.push(coreLayer);
        layer.document = this.document;
        
        super.cloneParameter(layer);
    }

    // JSON
    public toJSON()
    {
        var jsonObj = {};
        jsonObj = this.saveParameterToJson(jsonObj);
        return jsonObj;
    }

    public saveParameterToJson(jsonObject)
    {
        jsonObject.linkId = this._linkId;

        jsonObject = super.saveParameterToJson(jsonObject);

        return jsonObject;
    }

    public static createFromJsonData(jsonData : any) : NumberLayer
    {
        var layer = new NumberLayer();
        layer.loadParameterFromJson(jsonData);
        return layer;
    }

    public loadParameterFromJson(jsonData)
    {
        if(jsonData.linkId != null) { this._linkId = jsonData.linkId; }

        super.loadParameterFromJson(jsonData);
    }

    // 本体を取得する
    public getCoreLayer() : NumberCoreLayer 
    {
        if(this.document != null)
        {
            var layers = this.document.numberLayers;
            for(var i = 0; i < layers.length; ++i)
            {
                if(this.linkId == layers[i].linkId) { return layers[i]; }
            }
        }

        return new NumberCoreLayer();
    }
}

// 連番レイヤー本体
// documentで保持する
export class NumberCoreLayer extends ObjectLayer
{
    public get layerType() { return "number"; }

    // 参照Id
    private _linkId = "";
    public get linkId() { return this._linkId; }
    public set linkId(linkId) { this._linkId = linkId; }

    // 対象となるsurface
    private _surfaceIndex = 0;
    public get surfaceIndex() { return this._surfaceIndex; }
    public set surfaceIndex(surfaceIndex) { this._surfaceIndex = surfaceIndex; }

    // 文法情報
    private _textInfo = new TextInfo();
    public get textInfo() { return this._textInfo; }
    public set textInfo(textInfo) { this._textInfo = textInfo; }

    // 不透明度(%)
    private _opacity = 100;
    public get opacity() { return this._opacity; }
    public set opacity(opacity) { this._opacity = opacity; }

    // 開始番号
    private _startNumber = 1;
    public get startNumber() { return this._startNumber; }
    public set startNumber(startNumber) { this._startNumber = startNumber; }

    // 桁数(0の場合は表示なし)
    private _digits = 1;
    public get digits() { return this._digits; }
    public set digits(digits) { this._digits = digits; }

    // 増分
    private _step = 1;
    public get step() { return this._step; }
    public set step(step) { this._step = step; }

    // 自動(文字を枠に合わせたサイズにする)
    private _autoSize : boolean = false;
    public get autoSize() : boolean { return this._autoSize; }
    public set autoSize(autoSize : boolean) { this._autoSize = autoSize; }

    // 自動折り返し(ある程度で折り返す)
    private _autoNewLine : boolean = false;
    public get autoNewLine() : boolean { return this._autoNewLine; }
    public set autoNewLine(autoNewLine : boolean) { this._autoNewLine = autoNewLine; }

    // 行間(%)
    private _lineSpacing : number = 120;
    public get lineSpacing() : number { return this._lineSpacing; }
    public set lineSpacing(lineSpacing) { this._lineSpacing = lineSpacing; }
    
    // 文字方向
    // 0: 横書き
    // 1: 縦書き
    private _textOrientation : number = 0;
    public get textOrientation() : number { return this._textOrientation; }
    public set textOrientation(textOrientation : number ) { this._textOrientation = textOrientation; }

    // 水平揃え
    // 0: 左
    // 1: 中央
    // 2: 右
    // 3: 均等
    private _horizontalAlignment : number = 0;
    public get horizontalAlignment() : number { return this._horizontalAlignment; }
    public set horizontalAlignment(horizontalAlignment : number) { this._horizontalAlignment = horizontalAlignment; }

    // 垂直揃え
    // 0: 上
    // 1: 中央
    // 2: 下
    private _verticalAlignment : number = 0;
    public get verticalAlignment() : number { return this._verticalAlignment; }
    public set verticalAlignment(verticalAlignment : number) { this._verticalAlignment = verticalAlignment; }

    // 語頭追加
    private _prefix : string = "";
    public get prefix() : string { return this._prefix; }
    public set prefix(prefix : string) { this._prefix = prefix; }

    // 語尾追加
    private _suffix : string = "";
    public get suffix() : string { return this._suffix; }
    public set suffix(suffix : string) { this._suffix = suffix; }

    // 作成
    public static create(x : number, y : number, width : number, height : number) : NumberCoreLayer
    {
        var layer = new NumberCoreLayer();
        
        layer.autoSize = true;
        layer.autoNewLine = false;

        layer.horizontalAlignment = 0;
        layer.verticalAlignment = 0;
        layer.x = x;
        layer.y = y;
        layer.width = width;
        layer.height = height;
        
        return layer;
    }

    // 複製
    public clone()
    {
        var cloned = new NumberCoreLayer();
        this.cloneParameter(cloned);
        return cloned;
    }

    public cloneParameter(layer : NumberCoreLayer)
    {
        layer.linkId = this._linkId;
        layer.surfaceIndex = this._surfaceIndex;
        layer.textInfo = this._textInfo.clone();
        layer.opacity = this._opacity;
        layer.startNumber = this._startNumber;
        layer.digits = this._digits;
        layer.step = this._step;
        layer.autoSize = this._autoSize;
        layer.autoNewLine = this._autoNewLine;
        layer.lineSpacing = this._lineSpacing;
        layer.textOrientation = this._textOrientation;
        layer.horizontalAlignment = this._horizontalAlignment;
        layer.verticalAlignment = this._verticalAlignment;
        layer.prefix = this._prefix;
        layer.suffix = this._suffix;
        
        super.cloneParameter(layer);
    }
    

    // JSON
    public toJSON()
    {
        var jsonObj = {};
        jsonObj = this.saveParameterToJson(jsonObj);
        return jsonObj;
    }

    public saveParameterToJson(jsonObject)
    {
        jsonObject.linkId = this._linkId;
        jsonObject.surfaceIndex = this._surfaceIndex;
        jsonObject.textInfo = this._textInfo;
        jsonObject.opacity = this._opacity;
        jsonObject.startNumber = this._startNumber;
        jsonObject.digits = this._digits;
        jsonObject.step = this._step;
        jsonObject.autoSize = this._autoSize;
        jsonObject.autoNewLine = this._autoNewLine;
        jsonObject.lineSpacing = this._lineSpacing;
        jsonObject.textOrientation = this._textOrientation;
        jsonObject.horizontalAlignment = this._horizontalAlignment;
        jsonObject.verticalAlignment = this._verticalAlignment;
        jsonObject.prefix = this._prefix;
        jsonObject.suffix = this._suffix;

        jsonObject = super.saveParameterToJson(jsonObject);

        return jsonObject;
    }

    public static createFromJsonData(jsonData : any) : NumberCoreLayer
    {
        var layer = new NumberCoreLayer();
        layer.loadParameterFromJson(jsonData);
        return layer;
    }

    public loadParameterFromJson(jsonData)
    {
        if(jsonData.linkId != null) { this._linkId = jsonData.linkId; }
        if(jsonData.surfaceIndex != null) { this._surfaceIndex = jsonData.surfaceIndex; }
        if(jsonData.textInfo != null) { this._textInfo = TextInfo.createFromJsonData(jsonData.textInfo); }
        if(jsonData.opacity != null) { this._opacity = jsonData.opacity; }
        if(jsonData.startNumber != null) { this._startNumber = jsonData.startNumber; }
        if(jsonData.digits != null) { this._digits = jsonData.digits; }
        if(jsonData.step != null) { this._step = jsonData.step; }
        if(jsonData.autoSize != null) { this._autoSize = jsonData.autoSize; }
        if(jsonData.autoNewLine != null) { this._autoNewLine = jsonData.autoNewLine; }
        if(jsonData.lineSpacing != null) { this._lineSpacing = jsonData.lineSpacing; }
        if(jsonData.textOrientation != null) { this._textOrientation = jsonData.textOrientation; }
        if(jsonData.horizontalAlignment != null) { this._horizontalAlignment = jsonData.horizontalAlignment; }
        if(jsonData.verticalAlignment != null) { this._verticalAlignment = jsonData.verticalAlignment; }
        if(jsonData.prefix != null) { this._prefix = jsonData.prefix; }
        if(jsonData.suffix != null) { this._suffix = jsonData.suffix; }

        super.loadParameterFromJson(jsonData);
    }
}
